import { ArrowLeft } from 'lucide-react'
import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import styles from '../../pages/ToolsPage.module.css'

type ToolDetailHeaderProps = {
  action?: ReactNode
  subtitle: string
  title: string
}

const cx = (...classes: Array<string | false | null | undefined>): string =>
  classes
    .filter(Boolean)
    .map((className) => styles[className as string] ?? className)
    .join(' ')

export const ToolDetailHeader = ({ action, subtitle, title }: ToolDetailHeaderProps) => (
  <div className={cx('page-header', styles['tools-page-header'], styles['tools-page-header-detail'])}>
    <div className={styles['tools-header-copy']}>
      <Link className={styles['tools-back-link']} to="/admin/tools">
        <ArrowLeft size={16} />
        <span>Tools</span>
      </Link>
      <h1 className="page-title">{title}</h1>
      <p className="page-subtitle">{subtitle}</p>
    </div>
    {action}
  </div>
)
